<div class="cell small-12">
  <label>
    <span class="label-text">Use Custom Source:</span>
    <input type="checkbox" [(ngModel)]="componentData.config.customSource.enabled" />
  </label>
</div>

@if ((componentData.config.customSource && componentData.config.customSource.enabled)) {
  <div class="cell small-12">
    <label>
      <span class="label-text">Custom Source Path:</span>
      <input type="text" [(ngModel)]="componentData.config.customSource.path">
    </label>
  </div>
  <div class="cell small-12">
    <label>
      <span class="label-text">Id Property:</span>
      <input type="text" [(ngModel)]="componentData.config.customSource.idProperty">
    </label>
  </div>
  <div class="cell small-12">
    <label>
      <span class="label-text">Display Property:</span>
      <input type="text" [(ngModel)]="componentData.config.customSource.displayProperty">
    </label>
  </div>
}
@if (!(componentData.config.customSource && componentData.config.customSource.enabled)) {
  @if (!(isLoading$ | async)) {
    <div>
      <div class="cell small-12">
        <label>
          <span class="label-text">Choose Domain:</span>
          <select [(ngModel)]="componentData.config.domain" (ngModelChange)="fetchDomainValues()">
            @for (domain of domains | async; track domain) {
              <option [ngValue]="domain.id">{{domain.description}}</option>
            }
          </select>
        </label>
      </div>
      <div class="cell small-12">
        <label>
          <span class="label-text">Choose Id Property:</span>
          <select [(ngModel)]="componentData.config.idProperty" [disabled]="!componentData.config.domain && !(domainProperties | async)">
            @for (property of domainProperties | async; track property) {
              <option [ngValue]="property">{{property}}</option>
            }
          </select>
        </label>
      </div>
      <div class="cell small-12">
        <label>
          <span class="label-text">Choose Display Property:</span>
          <select [(ngModel)]="componentData.config.displayProperty" [disabled]="!componentData.config.domain && !(domainProperties | async)">
            @for (property of domainProperties | async; track property) {
              <option [ngValue]="property">{{property}}</option>
            }
          </select>
        </label>
      </div>
    </div>
  } @else {
    Loading data...
  }
}